"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _app = _interopRequireDefault(require("firebase/app"));

require("firebase/analytics");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// we need this for the Babel to include the analytics module in the build

/**
 * Tracks analytics events to Google Analytics service from the React Native app
 */
var FirebaseAnalyticsTrackerService = /*#__PURE__*/function () {
  function FirebaseAnalyticsTrackerService(firebaseConfig) {
    _classCallCheck(this, FirebaseAnalyticsTrackerService);

    _defineProperty(this, "customDimensionsTitlesMap", {
      dimension1: 'Vehicle Program',
      dimension2: 'Application Type',
      dimension3: 'Brand',
      dimension4: 'Type + SubType',
      dimension5: 'Model Year'
    });

    _app["default"].initializeApp(firebaseConfig);

    this.customDimensions = {}; // Initialize the setup

    this.analytics = _app["default"].analytics();
  }
  /**
   * Updates event context
   *
   * @param {Object} data
   * @returns {Object}
   */


  _createClass(FirebaseAnalyticsTrackerService, [{
    key: "set",
    value: function set(data) {
      this.customDimensions = _objectSpread(_objectSpread({}, this.customDimensions), data);
      return this.analytics.setUserProperties(data);
    }
    /**
     * Returns cached version of custom dimensions
     *
     * @return {{}|*}
     */

  }, {
    key: "getCustomDimensions",
    value: function getCustomDimensions() {
      return this.customDimensions;
    }
    /**
     * Tracks event
     *
     * @param {Object} event
     */

  }, {
    key: "event",
    value: function event(_ref) {
      var action = _ref.action,
          label = _ref.label,
          category = _ref.category;
      this.analytics.logEvent(this.getFirebaseEventName(category + '_' + action), _objectSpread({
        label: label
      }, this.getFirebaseParamsFromCustomDimensions()));
    }
    /**
     * Tracks screen view (NOOP)
     */

  }, {
    key: "screen",
    value: function screen() {// Automatic screen switching detection isn't supported on the WEB. We use custom events for this.
    }
    /**
     * Builds an event parameter name per Firebase custom events requirement
     *
     * @param {string} eventName
     * @returns {string}
     */

  }, {
    key: "getFirebaseEventName",
    value: function getFirebaseEventName(eventName) {
      return eventName.replace(/[\W_]+/g, "_").toLowerCase();
    }
    /**
     * Turns the custom dimensions values into Firebase params
     *
     * @returns {Object}
     */

  }, {
    key: "getFirebaseParamsFromCustomDimensions",
    value: function getFirebaseParamsFromCustomDimensions() {
      var _this = this;

      var data = {};
      var dimensions = this.getCustomDimensions();
      Object.keys(dimensions).forEach(function (key) {
        if (key in _this.customDimensionsTitlesMap) {
          data[_this.getFirebaseEventName(_this.customDimensionsTitlesMap[key])] = dimensions[key];
        }
      });
      return data;
    }
  }]);

  return FirebaseAnalyticsTrackerService;
}();

exports["default"] = FirebaseAnalyticsTrackerService;